import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';
import ParticleBackground from '@/components/base/ParticleBackground';
import { Link } from 'react-router-dom';

const jobs = [
  { title: 'AI编剧', dept: '内容创作部', type: '全职', location: '晋中·榆次', desc: '运用AI工具进行剧本创作、故事策划与内容构思，产出高质量漫剧/短剧剧本。', requirements: ['文学/编剧相关专业优先', '熟悉AI剧本创作工具', '有漫剧/短剧创作经验'] },
  { title: 'AI绘画设计师', dept: '内容创作部', type: '全职', location: '晋中·榆次', desc: '使用AI绘画工具进行角色设计、场景绘制与视觉风格把控。', requirements: ['美术/设计相关专业', '熟练使用AI绘画工具', '有良好的审美和视觉表达力'] },
  { title: '短视频剪辑师', dept: '后期制作部', type: '全职', location: '晋中·榆次', desc: '负责AI漫剧/短剧的后期剪辑、特效制作与成片输出。', requirements: ['熟练使用PR/AE等剪辑软件', '有短视频/短剧剪辑经验', '对节奏和叙事有敏感度'] },
  { title: '配音制作', dept: '后期制作部', type: '全职', location: '晋中·榆次', desc: '负责AI内容的智能配音、音效设计与音频后期处理。', requirements: ['音频制作相关经验', '熟悉AI配音工具', '有音效设计能力'] },
  { title: '账号运营', dept: '运营部', type: '全职', location: '晋中·榆次', desc: '负责各内容平台的账号运营、数据分析与粉丝增长。', requirements: ['1年以上新媒体运营经验', '熟悉主流短视频平台算法', '数据驱动的内容策略能力'] },
  { title: '跨境内容译制', dept: '海外事业部', type: '全职', location: '晋中·榆次', desc: '负责文化内容的海外多语种翻译与本土化适配。', requirements: ['英语/日语/韩语精通', '了解海外内容平台规则', '有字幕翻译/本地化经验'] },
  { title: '商务招商经理', dept: '商务部', type: '全职', location: '晋中·榆次', desc: '负责品牌合作洽谈、渠道拓展与商务关系维护。', requirements: ['3年以上商务/招商经验', '有品牌合作资源优先', '优秀的沟通谈判能力'] },
  { title: '项目运营经理', dept: '项目部', type: '全职', location: '晋中·榆次', desc: '统筹项目执行、资源协调与交付管理。', requirements: ['3年以上项目管理经验', '有文化/内容行业经验优先', '出色的统筹协调能力'] },
  { title: '校企合作专员', dept: '产教融合部', type: '全职', location: '晋中·榆次', desc: '负责高校合作对接、实训基地运营与人才招募。', requirements: ['有校企合作或教育行业经验', '熟悉高校运作流程', '优秀的沟通协调能力'] },
  { title: 'OPC社区运营专员', dept: '联盟协同部', type: '全职', location: '晋中·榆次', desc: '协同联盟推进县域OPC社区建设，组织人才培育、项目对接与社群运营。', requirements: ['具备社群运营或项目统筹经验', '熟悉AI内容工具与创作者生态', '具备跨团队协作和执行能力'] },
];

export default function Recruit() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">Join Us</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">招贤纳士</h1>
                   <p className="text-secondary-400 text-lg max-w-2xl mx-auto">以技术赋能人才，以平台成就价值，共建县域AI+OPC人才生态</p>
                </div>
              </ScrollReveal>

              {/* Stats */}
              <ScrollReveal>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-16">
                  {[
                     { value: 10, suffix: '', label: '热招岗位' },
                    { value: 6, suffix: '', label: '部门方向' },
                    { value: 3, suffix: '', label: '培养路径' },
                  ].map((stat) => (
                    <div key={stat.label} className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                        <CountUp end={stat.value} duration={2000} suffix={stat.suffix} />
                      </div>
                      <p className="text-secondary-400 text-xs md:text-sm">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <div className="group bg-background-900/50 rounded-2xl border border-primary-500/15 p-8 md:p-12 mb-16 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="text-center group/item">
                      <div className="w-14 h-14 mx-auto rounded-xl bg-accent-500/10 flex items-center justify-center mb-4 group-hover/item:bg-accent-500/20 group-hover/item:scale-110 transition-all duration-500">
                        <i className="ri-lightbulb-line text-accent-500 text-2xl"></i>
                      </div>
                      <h3 className="text-foreground-50 font-semibold text-base mb-2 group-hover/item:text-accent-400 transition-colors duration-500">岗前培训</h3>
                      <p className="text-secondary-400 text-sm">系统化AI工具与行业知识培训体系</p>
                    </div>
                    <div className="text-center group/item">
                      <div className="w-14 h-14 mx-auto rounded-xl bg-accent-500/10 flex items-center justify-center mb-4 group-hover/item:bg-accent-500/20 group-hover/item:scale-110 transition-all duration-500">
                        <i className="ri-rocket-line text-accent-500 text-2xl"></i>
                      </div>
                      <h3 className="text-foreground-50 font-semibold text-base mb-2 group-hover/item:text-accent-400 transition-colors duration-500">项目实战</h3>
                      <p className="text-secondary-400 text-sm">真实商业项目驱动，快速积累实战经验</p>
                    </div>
                    <div className="text-center group/item">
                      <div className="w-14 h-14 mx-auto rounded-xl bg-accent-500/10 flex items-center justify-center mb-4 group-hover/item:bg-accent-500/20 group-hover/item:scale-110 transition-all duration-500">
                        <i className="ri-seedling-line text-accent-500 text-2xl"></i>
                      </div>
                      <h3 className="text-foreground-50 font-semibold text-base mb-2 group-hover/item:text-accent-400 transition-colors duration-500">创业孵化</h3>
                      <p className="text-secondary-400 text-sm">为优秀人才提供创业扶持与资源对接</p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">热招岗位</h2>
              </ScrollReveal>
              <div className="space-y-4 mb-12">
                {jobs.map((job) => (
                  <ScrollReveal key={job.title}>
                    <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 hover:border-primary-500/25 transition-all duration-500 p-6 md:p-8 hover:-translate-y-1 hover:shadow-[0_0_25px_rgba(180,140,80,0.1)]">
                      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                        <div>
                          <div className="flex items-center gap-3 flex-wrap mb-2">
                            <h3 className="font-heading text-lg font-semibold text-foreground-50 group-hover:text-primary-500 transition-colors duration-500">{job.title}</h3>
                            <span className="px-2.5 py-0.5 rounded-full bg-accent-500/15 text-accent-300 text-xs whitespace-nowrap group-hover:bg-accent-500/25 transition-all duration-500">{job.type}</span>
                          </div>
                          <div className="flex items-center gap-4 text-secondary-500 text-xs">
                            <span className="flex items-center gap-1">
                              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-building-line"></i></div>
                              {job.dept}
                            </span>
                            <span className="flex items-center gap-1">
                              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-line"></i></div>
                              {job.location}
                            </span>
                          </div>
                        </div>
                        <Link
                          to="/contact"
                          className="group/btn px-5 py-2 bg-primary-500 text-background-950 font-medium rounded-full text-sm hover:bg-primary-400 transition-all duration-300 text-center whitespace-nowrap cursor-pointer hover:shadow-[0_0_15px_rgba(180,140,80,0.3)]"
                        >
                          投递简历
                        </Link>
                      </div>
                      <p className="text-secondary-400 text-sm mb-3">{job.desc}</p>
                      <div className="flex flex-wrap gap-2">
                        {job.requirements.map((req) => (
                          <span key={req} className="px-2.5 py-1 rounded-lg bg-secondary-500/8 text-secondary-400 text-xs hover:bg-secondary-500/15 hover:text-secondary-300 transition-all duration-300">{req}</span>
                        ))}
                      </div>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal>
                <div className="group text-center bg-background-900/50 rounded-2xl border border-primary-500/15 p-10 md:p-14 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <h3 className="font-heading text-2xl font-bold text-foreground-50 mb-4 group-hover:text-primary-500 transition-colors duration-500">加入我们</h3>
                  <p className="text-secondary-400 text-sm mb-8 max-w-xl mx-auto">请将简历发送至招聘邮箱，邮件标题格式：应聘岗位+姓名。作为联盟核心成员，员工可共享联盟培训中台资源与跨区域项目协作机会。</p>
                  <div className="inline-flex items-center gap-3 px-6 py-3 bg-background-800 rounded-full border border-primary-500/20 group-hover:border-primary-500/30 transition-all duration-500">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <span className="text-foreground-50 text-sm">hr@jinhuaxumeng.com</span>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
